import React from "react";
import PublicNavbar from "../components/nav/PublicNavbar";

const PublicLayout = ({ children }) => (
  <>
    <PublicNavbar />
    {children}
  </>
);

export default PublicLayout;
